// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.note.FindNotesByParentEntityRequest */
/* istanbul ignore next */
@GandalfModel
export class FindNotesByParentEntityRequest extends GandalfModelBase {

	@GandalfConstantDecorator(constants.EntityType)
	@GandalfValidator({ notNull: { message: 'Entity Type must not be null' } })
	@GandalfProperty({ designType: constants.EntityType, isRequired: true })
	entityType!: constants.EntityType;

	@GandalfValidator({ notNull: { message: 'Parent Id must not be null' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	parentId!: number;

}
